import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['library', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-4h0.5v2.5h-0.5zM-1.5,-3h0.5v1.5h-0.5zM0,-2.5h0.5v0.5h-0.5zM-3,-1.5h2v0.5h-2zM-3,-1h3.5v0.5h-3.5zM-2.5,-0.5h3v0.5h-3zM-1,0h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['library', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M2.5,-3.5h0.5v0.5h-0.5zM1.5,-3h1.5v0.5h-1.5zM0.5,-2.5h1v0.5h-1zM2.5,-2.5h0.5v2.5h-0.5zM0,-2h1v1h-1zM0.5,-1h0.5v1h-0.5zM0.5,0h1v0.5h-1z',
    },
    {
      paint: 'roofB',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-2,-6h1v0.5h-1zM-2.5,-5.5h1.5v0.5h-1.5zM-3,-5h2.5v0.5h-2.5zM-3.5,-4.5h2.5v0.5h-2.5zM-0.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h1.5v0.5h-1.5zM-1,-3.5h1v0.5h-1z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1,-6.5h0.5v0.5h-0.5zM-1,-6h2.5v0.5h-2.5zM-1,-5.5h3.5v0.5h-3.5zM-0.5,-5h3.5v0.5h-3.5zM0,-4.5h3.5v0.5h-3.5zM0.5,-4h3v0.5h-3zM-1.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h2v0.5h-2zM0,-3h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-2.5,-3.5h0.5v0.5h-0.5zM-2.5,-3h1v1.5h-1zM-0.5,-3h0.5v0.5h-0.5zM-1,-2.5h1v0.5h-1zM-0.5,-2h0.5v1h-0.5zM1.5,-2h0.5v2h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M-2,-3.5h0.5v0.5h-0.5zM-1,-3h0.5v0.5h-0.5zM1.5,-2.5h1v0.5h-1zM-1,-2h0.5v1h-0.5zM1,-2h0.5v2h-0.5zM2,-2h0.5v2h-0.5zM-3.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-3,0h2v0.5h-2zM1.5,0h2v0.5h-2zM-1,0.5h3v0.5h-3z',
    },
    { paint: 'sail', d: 'M-1,-4.5h0.5v0.5h-0.5zM-1,-4h1.5v0.5h-1.5zM0,-3.5h0.5v0.5h-0.5z' },
  ],
  pixels: 163,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
